import { useQuery } from '@tanstack/react-query';
import { ApiError } from 'src/types/interfaces/api-error';

import { hostsApi } from '../../api/lib/hosts';
import { discountHistoryKeys } from '../../api/query-keys/discount-history';
import { DiscountHistoryHost } from '../../api/types/discount';

import { PaginatedResponse } from '@/types/responses/paginated-response';

export const useHostDiscountHistory = ({
  hostId,
  page,
  perPage,
}: {
  hostId: number;
  page: number;
  perPage: number;
}) => {
  return useQuery<PaginatedResponse<DiscountHistoryHost>, ApiError>({
    queryKey: discountHistoryKeys.list(hostId, page, perPage),
    queryFn: () => hostsApi.fetchHostDiscountHistory(hostId, page, perPage),
  });
};
